module.exports = __webpack_public_path__ + "img/Users.2d2fcce3.svg";